import React from "react";
import HeroBanner from "../components/HeroBanner";
import AboutSection from "../components/Home/AboutSection";
import CompaniesSection from "../components/Home/CompaniesSection";
import CoreValueSection from "../components/Home/CoreValueSection";
import RecentProjects from "../components/Home/RecentProjects";
import ContactSection from "../components/ContactSection";
import Header from "../components/Header";
import Footer from "../components/Footer";

function Home() {
  return (
    <>
      <Header />
      <HeroBanner />
      <AboutSection />
      <CompaniesSection />
      <CoreValueSection />
      <RecentProjects />
      <ContactSection />
      <Footer />     
    </>
  );
}

export default Home;
